var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center mb-2 mx-5",staticStyle:{"min-height":"76px"}},[_c('v-img',{key:1,staticClass:"mx-auto",attrs:{"contain":"","position":"center","max-height":"76","src":_vm.src}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }